import React from 'react';
import Navbar from '../../components/Navbar';
import PageTitle from '../../components/pagetitle';
import Footer from '../../components/footer';
import Terms from '../../components/Terms';
import { useTranslation } from 'react-i18next';

const TermsPage = () => {
    const { t } = useTranslation();
    
    return (
        <div className="page-wrapper">
            <Navbar />
            <PageTitle pageTitle={t("footer.terms")} />
            <Terms />
            <Footer />
        </div>
    );
};

export default TermsPage;
